(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Chat"] = factory();
	else
		root["Chat"] = factory();
})(this, function() {
return webpackJsonpChat([1],{

/***/ "+h+a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+tYC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_message__ = __webpack_require__("eFEd");


var state = {
  // Current username
  user: '',

  // Room name
  room: '',

  // Link to backend
  service: '',

  // Websocket instance
  socket: null,

  // Is webscoket tonnected to backend
  connected: false,

  // Is websocket connecting now
  connecting: false,

  // Text of login error
  loginErrorText: '',

  // Current messages
  messages: [],

  // Size of message queue
  maxMessagesCount: 0,

  // Max length of a message
  maxMessageLength: 0,

  // Min time between messages, default 0 seconds
  timeBetweenMessages: 0,

  // Max length of sequence of equal messages
  maxEqualMessages: 0,

  // Time of the last sent message
  lastMessageTime: 0,

  // Last message
  lastMessage: '',

  // Count of equal messages
  equalMessages: 0
};

var getters = {
  user: function user(state) {
    return state.user;
  },
  room: function room(state) {
    return state.room;
  },
  service: function service(state) {
    return state.service;
  },

  connected: function connected(state) {
    return state.connected;
  },
  connecting: function connecting(state) {
    return state.connecting;
  },
  loginErrorText: function loginErrorText(state) {
    return state.loginErrorText;
  },

  messages: function messages(state) {
    return state.messages;
  },
  maxMessageLength: function maxMessageLength(state) {
    return state.maxMessageLength;
  },
  timeBetweenMessages: function timeBetweenMessages(state) {
    return state.timeBetweenMessages;
  },
  maxEqualMessages: function maxEqualMessages(state) {
    return state.maxEqualMessages;
  }
};

var actions = {
  connect: function connect(_ref, _ref2) {
    var state = _ref.state,
        commit = _ref.commit,
        getters = _ref.getters;
    var user = _ref2.user;

    commit('setConnecting');

    var socket = new WebSocket(state.service + '?user=' + user + '&room=' + state.room);
    socket.onopen = function () {
      commit('setSocket', { socket: socket });
    };

    socket.onerror = function () {
      commit('closeSocket');
    };

    socket.onclose = function (event) {
      commit('closeSocket');
    };

    socket.onmessage = function (event) {
      var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__models_message__["b" /* messageFromJSON */])(event.data);

      switch (message.type) {
        case __WEBPACK_IMPORTED_MODULE_0__models_message__["a" /* MESSAGE_TYPE */].LOGIN_SUCCESS:
          commit('setConnected');
          commit('setUser', { user: user });
          break;
        case __WEBPACK_IMPORTED_MODULE_0__models_message__["a" /* MESSAGE_TYPE */].LOGIN_ERROR:
          commit('setLoginErrorText', { error: [getters.backendErrorText(message.data.text)] });
          commit('closeSocket');
          break;
        case __WEBPACK_IMPORTED_MODULE_0__models_message__["a" /* MESSAGE_TYPE */].BROADCAST:
        case __WEBPACK_IMPORTED_MODULE_0__models_message__["a" /* MESSAGE_TYPE */].ERROR:
          commit('addMessage', { message: message });
          break;
      }
    };
  },
  disconnect: function disconnect(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit;

    state.socket.close();
  },
  sendMessage: function sendMessage(_ref4, _ref5) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    var text = _ref5.text;

    // Check if the last message was sent recently
    if ((new Date() - state.lastMessageTime) / 1000 < state.timeBetweenMessages) {
      // Error text should be the same as on backend
      var _message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__models_message__["c" /* newErrorMessage */])('you are sending messages too quickly');
      commit('addMessage', { message: _message });
      return;
    }

    var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__models_message__["d" /* newBroadcastMessage */])({
      text: text,
      usernameColor: this.getters.usernameColor.hex
    });

    // Check if the last message equals new message
    var equalMessages = 0;
    if (state.lastMessage === message.data.text) {
      equalMessages = state.equalMessages + 1;
    }
    if (equalMessages > state.maxEqualMessages) {
      // Error text should be the same as on backend
      var _message2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__models_message__["c" /* newErrorMessage */])('you are sending equal messages');
      commit('addMessage', { message: _message2 });
      return;
    }

    try {
      state.socket.send(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__models_message__["e" /* messageToJSON */])(message));
      commit('setLastMessageTime', { time: new Date() });

      if (state.lastMessage !== message.data.text) {
        commit('setLastMessage', { message: message.data.text });
        commit('setEqualMessages', { count: 0 });
      }
      commit('setEqualMessages', { count: state.equalMessages + 1 });
    } catch (err) {
      commit('closeSocket');
    }
  }
};

var mutations = {
  setUser: function setUser(state, _ref6) {
    var user = _ref6.user;

    state.user = user;
  },
  setRoom: function setRoom(state, _ref7) {
    var room = _ref7.room;

    state.room = room;
  },
  setService: function setService(state, _ref8) {
    var service = _ref8.service;

    state.service = service;
  },
  setSocket: function setSocket(state, _ref9) {
    var socket = _ref9.socket;

    state.socket = socket;
  },
  closeSocket: function closeSocket(state) {
    state.socket = null;
    state.connected = false;
    state.connecting = false;
    state.messages = [];
    state.user = '';
  },
  setConnecting: function setConnecting(state) {
    state.connecting = true;
  },
  setConnected: function setConnected(state) {
    state.connecting = false;
    state.connected = true;
    state.loginErrorText = '';
  },
  clearLoginErrorText: function clearLoginErrorText(state) {
    state.loginErrorText = '';
  },
  setLoginErrorText: function setLoginErrorText(state, _ref10) {
    var error = _ref10.error;

    state.loginErrorText = error;
  },
  addMessage: function addMessage(state, _ref11) {
    var message = _ref11.message;

    state.messages.push(message);

    if (state.messages.length > state.maxMessagesCount) {
      state.messages.shift();
    }
  },
  clearMessages: function clearMessages(state) {
    state.messages = [];
  },
  clearErrorMessages: function clearErrorMessages(state) {
    state.messages = state.messages.filter(function (message) {
      return message.type !== __WEBPACK_IMPORTED_MODULE_0__models_message__["a" /* MESSAGE_TYPE */].ERROR;
    });
  },
  setMaxMessageLength: function setMaxMessageLength(state, _ref12) {
    var maxMessageLength = _ref12.maxMessageLength;

    state.maxMessageLength = maxMessageLength;
  },
  setMaxMessagesCount: function setMaxMessagesCount(state, _ref13) {
    var maxMessagesCount = _ref13.maxMessagesCount;

    state.maxMessagesCount = maxMessagesCount;
  },
  setTimeBetweenMessages: function setTimeBetweenMessages(state, _ref14) {
    var timeBetweenMessages = _ref14.timeBetweenMessages;

    state.timeBetweenMessages = timeBetweenMessages;
  },
  setLastMessageTime: function setLastMessageTime(state, _ref15) {
    var time = _ref15.time;

    state.lastMessageTime = time;
  },
  setMaxEqualMessages: function setMaxEqualMessages(state, _ref16) {
    var maxEqualMessages = _ref16.maxEqualMessages;

    state.maxEqualMessages = maxEqualMessages;
  },
  setLastMessage: function setLastMessage(state, _ref17) {
    var message = _ref17.message;

    state.lastMessage = message;
  },
  setEqualMessages: function setEqualMessages(state, _ref18) {
    var count = _ref18.count;

    state.equalMessages = count;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "1R0t":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAU3SURBVGiB7ZppaFxVFMd/tqZJHGPRqKnWaNV0y1RNQ6sVQQT9IhREkWBEcP8mUkTauuBGXWrbWBWpuKD4RRHULy5tcYlVsIqllVqjIrVNI1gUNbFpmmSS54dzrvfNzJ37lnnTgvYPjzd5Z7/v3nPPPS9wFP8PPAEUgKDkGgXuOoJ+JcYvlAdhru1H0K9EmI44PAJMLXk+6XieCaZkrRDI670PmAg9HwT2Ag3AnKyNJgmkFbgTaIngm6f3PgftW73nHbQwZqitM2J7FxN5YD8yZf4CrvPwrlO+ex20R5X2iEe+S20EwK9EBx0bs4EBVfyn3ieB9cg0CaMB6FWeqx26rlfau5TPhjrgSdUdttUPtFUbxJxQEJ8CTcAKYEyf7QDa1dAL2JEMgHMc+uaH6PuAx4FTlfdLfT4GrFRbW0K8s9MG0YpNo58Bx4doi4AfsNlpXH8XgA/xT73bga1IIgiAYWBIf+8GloR4m4DPlTZAyjVzsyo4CDQ76DngxZAza4HTEuifCTyFDEQAvI6k6FKcrD4E6lNiNCKZJ0CmQCV0AKekMaBoAS700FerDz8hbygVOpCyYgK4PK2SKnAlsvhHgc5qld2DnaOuKVYrNGPX6P1ZKJyCZKwAeCsLhTHxttrsJcMKZC52wXVkpdSDS9TWAWKWM3EjnQSmIfXSnhj8eaAHKUl+02snsuu3x5DvR/YTgD9i+hgLJs0+HMFXBzyL+yxirgLwtPL6sEH5H0rrdCkakDcxhn+xTwM2qfFDSLlxAXCiXh3AGiQDBcBGlamEc5VvDynXSBOS129FpoIpEzZGyJkRHMC/jjqx2ei5CJ3blG8zMjA3AYsprjLK8BjwM+7pMAFc45HNI1NmBDg/wjmQQA+pjG/N3FHBn0n1dZVLyNQ+g0gB9zJwN7IpzYxwbL3KrosRRKlMTwTfLGApsBx4BfgKW5sVXAIm2jT4TmUXJZC5SGV2prRZ0d9qAvlbZXMJZJpUZiilzSJ/s9oxj8lIT2q4AvGlxEro1/v8BDJmkfd7udyoL31wbOh3Qf8eBn5E5u43yO68AzmlVcJmJIhu4OuYznSHZH04G9mPFgDn6WVOi87FvhJx3BxjS9PdtR5j7cgpMWn6Hcd2XVyolH5HkcFd7jNSp87cgBxqzIb4XoRzPSTfENdE6NyufJuQw1038maiyhsnGpGmwihSalRCHbL7mxHbgKTjer0WA89j3/gHFE/tUsxTvr1kWMab8sPXj4Jsi8aXiFeoJkKbOjAEnBSD35Txu5B1M4IkjbhlfCvy5g5QXT+gDO3YbkecxVwtLsZ2Z5KkdC8akZENkDl+uGCm1i7guCwUPqMK+7JSGBM54HvilfuRWIptxyysVlkKdGIPYlelVdKM7fve5+FbiHQD02IGcKmH/oD6sF95E2MZtivu6vBNB17DdjtWk7xl2oPtzryJOyM2YZvjyxLo/xdnYd/IRxSvj8uQjcr0hs2+MYE0nW/06L0F+ILiJvYgtiq4IsSbAz7GduTPTBMISHG2TxV9gky3tSEntirPLGR0f8fWZq0V9JmNcQD5+tuCDNqWkGyP2uoNBVH1N5K2UDBmLxkHHqS8xKhHPkEESKIoRZfS3qe87JiKfOUyJYyx1Y90VDJBK9IND5Cqc4GH13x6W+GgrSK67MirDdOBd73ZqnA6UhFHHWdvUydeddDeUVpXhI4c8kEoqulRUyxBnHUdsHYrbe5h9SglTkAW7DDF68A8P0gN/mGgVjDJwXVtq4XBWvznA8AbuFtLk8i3wqP4z+MfehOvjVdiGMUAAAAASUVORK5CYII="

/***/ }),

/***/ "6YnN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"chat-scroll",rawName:"v-chat-scroll"}],staticClass:"messages d-flex flex-column"},_vm._l((_vm.messages),function(message){return _c('message',{key:message.id,attrs:{"message":message}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7UCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInput_vue__ = __webpack_require__("QF19");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d61762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInput_vue__ = __webpack_require__("z0ek");
function injectStyle (ssrContext) {
  __webpack_require__("T+NL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62d61762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d61762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7ZMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message_vue__ = __webpack_require__("yJ2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chat_scroll__ = __webpack_require__("bNL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chat_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_chat_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_chat_scroll___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MessageList',

  components: {
    Message: __WEBPACK_IMPORTED_MODULE_1__Message_vue__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['messages']))
});

/***/ }),

/***/ "9MHI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BkMr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat d-flex",style:(_vm.style)},[(_vm.connected)?_c('div',{staticClass:"chat-main"},[_c('div',{staticClass:"chat-header"},[_c('chat-header')],1),_vm._v(" "),_c('div',{staticClass:"chat-messages"},[_c('message-list')],1),_vm._v(" "),_c('div',{staticClass:"chat-message-input"},[_c('message-input')],1)]):_c('div',{staticClass:"chat-login-form align-self-center"},[_c('login-form')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EWfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("EZYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a02523dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("BkMr");
function injectStyle (ssrContext) {
  __webpack_require__("+h+a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a02523dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a02523dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageInput__ = __webpack_require__("7UCQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageList__ = __webpack_require__("ib2o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoginForm__ = __webpack_require__("gosb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    MessageInput: __WEBPACK_IMPORTED_MODULE_1__MessageInput__["a" /* default */],
    MessageList: __WEBPACK_IMPORTED_MODULE_2__MessageList__["a" /* default */],
    ChatHeader: __WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_3__LoginForm__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['connected', 'style'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['logout']))
});

/***/ }),

/***/ "FyVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  // Styles of chat container
  // New styles should place here
  style: {
    width: '',
    height: ''
  },

  // Show time of message
  showMessageTime: false,

  // Username color (black)
  usernameColor: {
    hex: '#000000',
    hsl: {
      h: 0,
      s: 0,
      l: 0,
      a: 1
    },
    hsv: {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    },
    rgba: {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    },
    a: 1
  },

  // Palette for username
  palette: ['#4D4D4D', '#999999', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#808080', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],

  // Color of username link text
  usernameLinkTextColor: '#FFFFFF',

  // Color of username link background
  usernameLinkBackground: '#FFA500'
};

var getters = {
  style: function style(state) {
    return state.style;
  },
  showMessageTime: function showMessageTime(state) {
    return state.showMessageTime;
  },
  usernameColor: function usernameColor(state) {
    return state.usernameColor;
  },
  palette: function palette(state) {
    return state.palette;
  },
  usernameLinkTextColor: function usernameLinkTextColor(state) {
    return state.usernameLinkTextColor;
  },
  usernameLinkBackground: function usernameLinkBackground(state) {
    return state.usernameLinkBackground;
  }
};

var actions = {};

var mutations = {
  setStyle: function setStyle(state, _ref) {
    var height = _ref.height,
        width = _ref.width;

    state.style.height = height;
    state.style.width = width;
  },
  setUsernameColor: function setUsernameColor(state, _ref2) {
    var color = _ref2.color;

    state.usernameColor = color;
  },
  setShowMessageTime: function setShowMessageTime(state, _ref3) {
    var showMessageTime = _ref3.showMessageTime;

    state.showMessageTime = showMessageTime;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Settings__ = __webpack_require__("niH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_js_popover___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChatHeader',

  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_0__Settings__["a" /* default */]
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_language__ = __webpack_require__("sLCT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_styles__ = __webpack_require__("FyVt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_core__ = __webpack_require__("+tYC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__ = __webpack_require__("UIay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger__ = __webpack_require__("sax8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");









__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* default */]);

var isDebug = "production" !== 'production';

var plugins = [__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate___default()({ key: 'chat' })];
if (isDebug) {
  plugins.push(__WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger___default()());
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* default */].Store({
  modules: {
    language: __WEBPACK_IMPORTED_MODULE_0__modules_language__["a" /* default */],
    styles: __WEBPACK_IMPORTED_MODULE_1__modules_styles__["a" /* default */],
    core: __WEBPACK_IMPORTED_MODULE_2__modules_core__["a" /* default */]
  },
  strict: isDebug,
  plugins: plugins
}));

/***/ }),

/***/ "JZSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color__ = __webpack_require__("Zzkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_color__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',

  components: {
    Compact: __WEBPACK_IMPORTED_MODULE_2_vue_color__["Compact"]
  },

  data: function data() {
    return {
      showMessageTimeInput: '',
      languageInput: '',
      colors: ''
    };
  },

  mounted: function mounted() {
    this.showMessageTimeInput = this.showMessageTime;
    this.languageInput = this.language;
    this.colors = this.usernameColor;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['showMessageTimeCheckboxText', 'usernameColorPickerText', 'clearMessagesButtonText', 'languageSelectText', 'logoutButtonText', 'showMessageTime', 'usernameColor', 'languages', 'language', 'palette'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['setShowMessageTime', 'setUsernameColor', 'clearMessages', 'setLanguage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['disconnect']), {

    logout: function logout(event) {
      this.disconnect();
    },

    clear: function clear(event) {
      this.clearMessages();
    }
  }),

  watch: {
    colors: function colors(selectedColor) {
      this.setUsernameColor({ color: selectedColor });
    },

    showMessageTimeInput: function showMessageTimeInput(showMessageTime) {
      this.timeInput = showMessageTime;
      this.setShowMessageTime({ showMessageTime: showMessageTime });
    },

    languageInput: function languageInput(language) {
      this.languageInput = language;
      this.setLanguage({ language: language });
    }
  }
});

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JnGT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__("EWfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;

/**
 * Initialize the application
 * @param {String} el - application element (#app)
 * @param {String} room - name of the room
 * @param {String} width - width of the chat in px, default 300px
 * @param {String} height - height of the chat in px, default 360px
 * @param {String} service - link to the chat backend
 * @param {String} language - UI language, default EN
 * @param {Number} maxMessageLength - max length of the message, default 255
 * @param {Number} maxMessageCount - max length of the message, default 50
 * @param {Number} timeBetweenMessages - min time between messages, default 0 seconds
 * @param {Number} maxEqualMessages - max length of sequence of equal messages, default 100
 */
function init(_ref) {
  var el = _ref.el,
      service = _ref.service,
      room = _ref.room,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? '300px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? '360px' : _ref$height,
      _ref$language = _ref.language,
      language = _ref$language === undefined ? 'EN' : _ref$language,
      _ref$maxMessageLength = _ref.maxMessageLength,
      maxMessageLength = _ref$maxMessageLength === undefined ? 255 : _ref$maxMessageLength,
      _ref$maxMessagesCount = _ref.maxMessagesCount,
      maxMessagesCount = _ref$maxMessagesCount === undefined ? 50 : _ref$maxMessagesCount,
      _ref$timeBetweenMessa = _ref.timeBetweenMessages,
      timeBetweenMessages = _ref$timeBetweenMessa === undefined ? 0 : _ref$timeBetweenMessa,
      _ref$maxEqualMessages = _ref.maxEqualMessages,
      maxEqualMessages = _ref$maxEqualMessages === undefined ? 100 : _ref$maxEqualMessages;

  if (!el) {
    throw new Error('El is not provided');
  }

  if (!service) {
    throw new Error('Service is not provided');
  }

  if (!room) {
    throw new Error('Room is not provided');
  }

  var languagesArr = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.language.languages;
  var supportedLanguages = languagesArr.map(function (lang) {
    return lang.code;
  });
  if (supportedLanguages.indexOf(language) === -1) {
    throw new Error('Incorrect language, supported: ' + supportedLanguages);
  }

  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    el: el,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__components_App__["a" /* default */] },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['connected', 'language', 'user'])),

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['setRoom', 'setStyle', 'setService', 'setLanguage', 'clearMessages', 'clearErrorMessages', 'setMaxMessageLength', 'setMaxMessagesCount', 'setMaxEqualMessages', 'clearLoginErrorText', 'setTimeBetweenMessages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['connect'])),

    mounted: function mounted() {
      this.setRoom({ room: room });
      this.setStyle({ height: height, width: width });
      this.setService({ service: service });
      this.setMaxMessageLength({ maxMessageLength: maxMessageLength });
      this.setMaxMessagesCount({ maxMessagesCount: maxMessagesCount });
      this.setTimeBetweenMessages({ timeBetweenMessages: timeBetweenMessages });
      this.setMaxEqualMessages({ maxEqualMessages: maxEqualMessages });

      this.clearLoginErrorText();
      this.clearErrorMessages();

      // If language was changed before refresh
      if (!this.language) {
        this.setLanguage({ language: language });
      }

      // Reconnect after page refresh
      if (this.connected && this.user) {
        this.connect({ user: this.user });
      }
    }
  });
}

/***/ }),

/***/ "P69c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QF19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MessageInput',

  data: function data() {
    return {
      text: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['enterMessageText', 'maxMessageLength'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['sendMessage']), {
    processEnter: function processEnter(e) {
      this.text = this.text.replace(/(\r\n|\n|\r)/gm, '');
      if (!this.text) {
        return;
      }

      this.sendMessage({ text: this.text });
      this.text = '';
    }
  })
});

/***/ }),

/***/ "T+NL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VNiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header d-flex align-items-center justify-content-end"},[_c('img',{directives:[{name:"popover",rawName:"v-popover:settings",arg:"settings"}],staticClass:"header-settings-icon",attrs:{"src":__webpack_require__("1R0t")}}),_vm._v(" "),_c('popover',{attrs:{"name":"settings","pointer":false,"width":250}},[_c('settings')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eFEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MESSAGE_TYPE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = newBroadcastMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = newErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["e"] = messageToJSON;
/* harmony export (immutable) */ __webpack_exports__["b"] = messageFromJSON;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/*
// Base structure of a message
{
  type: String,             // MESSAGE_TYPE
  from: String,             // Filled in backend
  room: String,             // Filled in backend
  timestamp: Int,           // Filled in backend, UNIX
  data: {
    text: String,
    settings: {             // Only in Broadcast
      usernameColor: String // Hex format
    }
  }
}
*/

// Possible types of message
var MESSAGE_TYPE = {
  LOGIN_SUCCESS: 'LoginSuccess',
  LOGIN_ERROR: 'LoginError',
  ERROR: 'Error',
  BROADCAST: 'Broadcast'

  // Makes message to send to backend
};function newBroadcastMessage(_ref) {
  var text = _ref.text,
      usernameColor = _ref.usernameColor;

  return {
    type: MESSAGE_TYPE.BROADCAST,
    data: {
      text: text,
      settings: {
        usernameColor: usernameColor
      }
    }
  };
}

// Internal error message (used only in frontend)
function newErrorMessage(text) {
  return {
    type: MESSAGE_TYPE.ERROR,
    id: generateID(),
    timestamp: getHoursAndMinutes(new Date()),
    data: {
      text: text
    }
  };
}

// Serialize message to sent to backend
function messageToJSON(message) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    type: message.type,
    data: message.data
  });
}

// Deserialize message received from backend
function messageFromJSON(message) {
  var rawMessage = JSON.parse(message);

  rawMessage.id = generateID();

  var date = dateFromTimestamp(rawMessage.timestamp);
  rawMessage.timestamp = getHoursAndMinutes(date);

  return rawMessage;
}

function generateID() {
  var S4 = function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  };
  return '' + S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}

function dateFromTimestamp(timestamp) {
  return new Date(timestamp * 1000);
}

function getHoursAndMinutes(date) {
  return date.toLocaleTimeString(navigator.language, {
    hour: '2-digit',
    minute: '2-digit'
  });
}

/***/ }),

/***/ "gDFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"login-form",on:{"submit":function($event){$event.preventDefault();_vm.login($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.username),expression:"username",modifiers:{"trim":true}}],staticClass:"username form-control",class:{ 'is-invalid': _vm.loginErrorText },attrs:{"id":"username","type":"text","placeholder":_vm.enterUsernameText,"autofocus":"","required":""},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.loginErrorText)?_c('div',{staticClass:"invalid-feedback"},[_c('ul',{staticClass:"error-list list-unstyled"},_vm._l((_vm.loginErrorText),function(error){return _c('li',[_vm._v("\n          "+_vm._s(error)+"\n        ")])}))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"join btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.connecting}},[_vm._v("\n    "+_vm._s(_vm.loginButtonText)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gosb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("pFqp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc84afe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("gDFc");
function injectStyle (ssrContext) {
  __webpack_require__("JnGT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5dc84afe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc84afe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hzO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('div',{staticClass:"color-form form-group"},[_c('label',{staticClass:"color-label",attrs:{"for":"color-input"}},[_vm._v("\n           "+_vm._s(_vm.usernameColorPickerText)+"\n    ")]),_vm._v(" "),_c('compact',{staticClass:"color-picker",attrs:{"id":"color-input","palette":_vm.palette},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),_c('div',{staticClass:"language-form form-group"},[_c('label',{staticClass:"language-label",attrs:{"for":"language-input"}},[_vm._v("\n           "+_vm._s(_vm.languageSelectText)+"\n    ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageInput),expression:"languageInput"}],staticClass:"language-select form-control form-control-sm",attrs:{"id":"language-input"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.languageInput=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.languages),function(option){return _c('option',{domProps:{"value":option.code}},[_vm._v("\n              "+_vm._s(option.text)+"\n      ")])}))]),_vm._v(" "),_c('div',{staticClass:"time-form form-check"},[_c('label',{staticClass:"form-check-label time-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showMessageTimeInput),expression:"showMessageTimeInput"}],staticClass:"form-check-input time-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showMessageTimeInput)?_vm._i(_vm.showMessageTimeInput,null)>-1:(_vm.showMessageTimeInput)},on:{"change":function($event){var $$a=_vm.showMessageTimeInput,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showMessageTimeInput=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showMessageTimeInput=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showMessageTimeInput=$$c}}}}),_vm._v("\n             "+_vm._s(_vm.showMessageTimeCheckboxText)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"button-form"},[_c('button',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.logout}},[_vm._v("\n            "+_vm._s(_vm.logoutButtonText)+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.clear}},[_vm._v("\n            "+_vm._s(_vm.clearMessagesButtonText)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ib2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__ = __webpack_require__("7ZMd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d2a236_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__ = __webpack_require__("6YnN");
function injectStyle (ssrContext) {
  __webpack_require__("vpmG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68d2a236"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d2a236_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "niH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("JZSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc2a9fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("hzO4");
function injectStyle (ssrContext) {
  __webpack_require__("9MHI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cc2a9fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc2a9fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pFqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginForm',

  data: function data() {
    return {
      username: '',
      regex: /^[A-Za-z]\w{2,16}$/
    };
  },

  watch: {
    username: function username(val) {
      this.username = val;

      if (this.loginErrorText) {
        this.clearLoginErrorText();
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['usernameErrorText', 'enterUsernameText', 'loginButtonText', 'loginErrorText', 'connecting'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['connect']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['clearLoginErrorText', 'setLoginErrorText']), {
    login: function login() {
      var valid = this.regex.test(this.username);
      if (!valid) {
        this.setLoginErrorText({ error: this.usernameErrorText });
        return;
      }

      this.connect({ user: this.username });
    }
  })
});

/***/ }),

/***/ "rAxf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sLCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  // Current language of UI
  language: '',

  // Supported languages
  languages: [{ code: 'EN', text: 'English' }, { code: 'RU', text: 'Русский' }],

  // MessageInput.vue
  enterMessageText: {
    'EN': 'Enter message...',
    'RU': 'Введите сообщение...'
  },

  // LoginForm.vue
  enterUsernameText: {
    'EN': 'Enter username',
    'RU': 'Введите имя'
  },
  loginButtonText: {
    'EN': 'Join',
    'RU': 'Присоединиться'
  },
  usernameErrorText: {
    'EN': ['Username must be between 3 and 16 characters in length', 'Allowed only alphanumeric characters and underscores', 'The first symbol is character'],
    'RU': ['Имя пользователя должно быть длиной от 3 до 16 символов', 'Можно использовать числа, буквы и символы подчеркивания', 'Первый символ - буква']
  },

  // Settings.vue
  usernameColorPickerText: {
    'EN': 'Username color',
    'RU': 'Цвет имени пользователя'
  },
  languageSelectText: {
    'EN': 'Language',
    'RU': 'Язык'
  },
  showMessageTimeCheckboxText: {
    'EN': 'Show timestamps',
    'RU': 'Показывать время'
  },
  logoutButtonText: {
    'EN': 'Logout',
    'RU': 'Выйти'
  },
  clearMessagesButtonText: {
    'EN': 'Clear messages',
    'RU': 'Очистить сообщения'
  },

  // Errors from backend
  backendErrorText: {
    'username is invalid': {
      'EN': 'Username is incorrect',
      'RU': 'Некорректное имя пользователя'
    },
    'user already exists': {
      'EN': 'User already exists',
      'RU': 'Пользователь уже существует'
    },
    'room is invalid': {
      'EN': 'Room name is invalid',
      'RU': 'Некорректное название комнаты'
    },
    'room is empty': {
      'EN': 'Room name is empty',
      'RU': 'Отсутствует название комнаты'
    },
    'user is empty': {
      'EN': 'Username is empty',
      'RU': 'Отсутствует имя пользователя'
    },
    'you are sending messages too quickly': {
      'EN': 'You are sending messages too quickly',
      'RU': 'Вы слишком часто отправляете сообщения'
    },
    'you are sending equal messages': {
      'EN': 'You are sending equal messages',
      'RU': 'Вы отправляете одинаковые сообщения'
    }
  }
};

var getters = {
  language: function language(state) {
    return state.language;
  },
  languages: function languages(state) {
    return state.languages;
  },

  enterMessageText: function enterMessageText(state) {
    return state.enterMessageText[state.language];
  },

  enterUsernameText: function enterUsernameText(state) {
    return state.enterUsernameText[state.language];
  },
  loginButtonText: function loginButtonText(state) {
    return state.loginButtonText[state.language];
  },
  usernameErrorText: function usernameErrorText(state) {
    return state.usernameErrorText[state.language];
  },

  usernameColorPickerText: function usernameColorPickerText(state) {
    return state.usernameColorPickerText[state.language];
  },
  languageSelectText: function languageSelectText(state) {
    return state.languageSelectText[state.language];
  },
  showMessageTimeCheckboxText: function showMessageTimeCheckboxText(state) {
    return state.showMessageTimeCheckboxText[state.language];
  },
  logoutButtonText: function logoutButtonText(state) {
    return state.logoutButtonText[state.language];
  },
  clearMessagesButtonText: function clearMessagesButtonText(state) {
    return state.clearMessagesButtonText[state.language];
  },

  backendErrorText: function backendErrorText(state) {
    return function (errorText) {
      try {
        return state.backendErrorText[errorText][state.language];
      } catch (err) {
        return errorText;
      }
    };
  }
};

var actions = {};

var mutations = {
  setLanguage: function setLanguage(state, _ref) {
    var language = _ref.language;

    state.language = language;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2328522c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("VNiM");
function injectStyle (ssrContext) {
  __webpack_require__("P69c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2328522c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2328522c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uWuI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAArCAYAAAA65tviAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAABoJJREFUaAXNmVuIVXUUxrOLZU5lV410qN6CLlgUFhQ9BKEZaUEZRmpQpD1k90ASQssiqCi6YdlEPRT00OUpEBx8KnuokNCStFG0m9EgpZVZfb+z1zdnzZ5z9pxzOmMu+P6XdV9r//c+e8+MO6xzGifTI4S/wsV4zTOEy4XpwpnCZOFUAfpJ+EEYED4T+oVPhP0CdKRwQPiHzcEigpqmavGo8JVAEu1gk/RXCL2CKfs2b9SZrrZLBOIqTBAeEZYIJwiZBrWh898Lv4WgR/MUYZpwYvA87dHiOYGi/hQcQ8vuE0UfHm6v0PyNkLu/S/uXhGsFrpJ1tRwieGcIs4VXhO+E7GOL9lcKELqdNLpm3GzAoZ0u1ToHp+v3CMcLZXLxzZKaJIO7BZqQfd4bjnLcYHU+ORk8rBJywDXak4yJIwGaJW5f1rMdR7NPyL5XhpAHSleIoNDDQg50R41bDEdpIvl2CZvxyWix1jnG/SFzDkm1vSUJQrOEHOD6Grfe/dh2PFGQk52jdY7F/QRZXuzaGN3hU2Tzo2DnC8KHi2zD5QhVjlomX51bxHS83VqfFkrOKduMuvbZfE2advp0WHWzCJLLCbrzPI4d9/WI65xiO/pkgwukym8GDr8WHCQHFrtt8pXIDTHPvo+RVz/iD2h9bkRxbi0FtfJqabsr88MyB2/JWUnJieJng/CEYJ8uxvtbJXN8fqMgN7PYVYwOxDuS740vtTbfwSpcVIqcSD46j4eFZY5BQzcKFMOPp98InItYzcnObpSKu7E81N2p5tbVEtvPTL53aj0tzHKC1l2WdOeGnnOMbePJSs8nB7zVQj5yxa690UkeJ7MdgpvE4xZy3GJXj3WxGNwj6D8TwrJusOuTLymcdQLG2wV+eaEsLzitj27CWzJxEVXn3rF6pL8tbNZGOMtiO3KywtES8ZQi4PqkZnli1ZZ024mWZex9TBZq7SJ4hTffV0usYeR4/eJihw1PM8iy2qbswMKJknIEID6IIHRxViYK+Fvg8je65Mj3C2cJLwimhVrApxjsG5Hzcw68mHKFRpAVywKcO6nfy8K0J0kK6BUuFfjNgeeGMDvJV7U+VoBWCnwdEodiRiPnQE7OyzEa2rqwkyXl9Zwr8G5oWhbboWQ5husFdG+yUDP6PjpLtUYOPhVMlclIiaZA7wjY7hR4ZYIqbS1s5R5xZxbJqZNkfoooic7Tmq4j2yecI0BOstg1Hp3POomx3yw0vEfK5jaEb+MBrf3RlOXoeM+HFYGMj7SeIEBfCObfWePUr1RsG072zXHcKuCj5acWHt1pbkwncAkCUbmLDoZstrBXsM3HWvel/YdaQ+UjWnBHjo41XSLuPfw+G2rOMbaNJyvNk9hJLQtVn/lsSTHmc2wa/TVlUPzTw8gJxrbpZJ8PScN53BDazrGpMQJ3jG+A3QJONgruvmexhpEDc4bfE7D7I2Y/BKwjdiU5BvPnAr541zpJgJxjsasY3bU10nE3Wkkmd2pF2OIDss9iVz264HwqXg6THKPai6QOepHW/A5QzCbBnfAs1giyLQI+iaeERpVNqNQm65HwZoHY5HC+AGX/BWeU0QZvSM9X5cmwcceaueBI2B4dJ9dMP/Ptm8e44/aFQvaZbSrXDp7vFRzfHFYOWOWEwD7vVXqW+ZudY+wiuE/JAXJOxa6N0cleJxs7ZuZRCyHv2HnNQzHgw2cf3z7OxOIvl5Dlxa6D0Q6WyzYXsyD5+i8F5St2eynGAxHDOaSQ7S8J5GD8FSUX86L2PcklAQEdtk0S13hZZh3eAngqZd+PhWE3rvhQDrmYB0sBd2i/RJg4pF1fkAT3CSgnBM+d5upShN/J7tMaynELThdGnDqZq7TeLuQODmjPK8TVwmShGU2VYFII/T62SHv7uitkFEnMMSEcu4t8eHHUfhWchGf++rJBeF94M/BB8AY1U/QMwXSbFradGUzuuzEnF0OgswV+X7YKTqaVmRdBd39+sp2rNZRjFJyKkXPaCfF45Jhh/7PA6/VqoV/4Vtgj8J8nkmXeK/wibBG2Cb0C9rMEHhb7hGsE6G2BX3TkxDloRMBG3eMY8h3DjxlgbVqsRb5qHE/f6HNCqZFP24/p7PuHBCiuGaEHXSbsEiiI7/5DphDlMoxImIIy4AHfyHx/cywp5pAtRLlVkotBaZXgo9a1V5LK6F0W5ocNTyuKmRcx/rd7pNMaOWpO+kKtAVR1nxUaafwXW9p5gIqqySEAAAAASUVORK5CYII="

/***/ }),

/***/ "vaj8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_message__ = __webpack_require__("eFEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Message',

  props: {
    message: Object
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user', 'usernameColor', 'showMessageTime', 'backendErrorText', 'usernameLinkTextColor', 'usernameLinkBackground'])),

  render: function render(createElement) {
    var _this = this;

    var innerElements = [];
    if (this.showMessageTime) {
      var timestamp = createElement('small', {
        attrs: {
          class: 'text-muted'
        }
      }, [this.message.timestamp + ' ']);
      innerElements.push(timestamp);
    }

    if (this.message.from) {
      var from = createElement('b', {
        style: {
          color: this.message.data.settings.usernameColor
        }
      }, [this.message.from + ': ']);
      innerElements.push(from);
    }

    var text = '';
    switch (this.message.type) {
      case __WEBPACK_IMPORTED_MODULE_1__models_message__["a" /* MESSAGE_TYPE */].BROADCAST:
        var innerText = [];
        var messageText = this.message.data.text;
        var linkToUsername = '@' + this.user;
        if (messageText.indexOf(linkToUsername) !== -1) {
          var messageChunks = messageText.split(linkToUsername);
          messageChunks.forEach(function (chunk, i, array) {
            innerText.push(chunk);
            if (i !== messageChunks.length - 1) {
              innerText.push(createElement('span', {
                style: {
                  backgroundColor: _this.usernameLinkBackground,
                  color: _this.usernameLinkTextColor
                },
                attrs: {
                  class: 'message-user-link'
                }
              }, [linkToUsername]));
            }
          });
        } else {
          innerText.push(messageText);
        }
        text = createElement('span', {
          attrs: {
            class: 'message-text'
          }
        }, innerText);
        break;
      case __WEBPACK_IMPORTED_MODULE_1__models_message__["a" /* MESSAGE_TYPE */].ERROR:
        text = createElement('i', {
          attrs: {
            class: 'text-muted'
          }
        }, [this.backendErrorText(this.message.data.text)]);
        break;
    }
    innerElements.push(text);

    return createElement('div', { attrs: { class: 'message' } }, innerElements);
  }
});

/***/ }),

/***/ "vpmG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yJ2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__("vaj8");
function injectStyle (ssrContext) {
  __webpack_require__("rAxf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c3a0710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z0ek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.text),expression:"text",modifiers:{"trim":true}}],staticClass:"input text",attrs:{"placeholder":_vm.enterMessageText,"maxlength":_vm.maxMessageLength},domProps:{"value":(_vm.text)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.processEnter($event)},"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('img',{staticClass:"send-img",attrs:{"src":__webpack_require__("uWuI")},on:{"click":_vm.processEnter}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);
});


// WEBPACK FOOTER //
// static/js/app.1a76822e7d640e343964.js